/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import corsImg from 'assets/images/cors.png'
import { CopyBlock, ocean } from 'react-code-blocks'

export const _4 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>4 - Кроссдоменные запросы</h2>
    <p className={styles.description}>
      Обычно HTTP-запрос можно делать только в рамках текущего сайта. При попытке использовать другой
      домен/порт/протокол — браузер выдаёт ошибку. Это сделано из соображений безопасности и настраивается на стороне
      сервера.
    </p>
    <p className={styles.notificationWarn}>
      Если бекенд не поддерживает CORS-запросы, то фронтенд-разработчик ничего не сможет с этим сделать в своем коде.{' '}
    </p>
    <p className={styles.description}>Общая идея заключается в следующих шагах: </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        Перед самим запросом браузер делает <b>preflight-запрос</b>, информируя сервер о том, что он (браузер) хочет
        сделать HTTP-запрос с такого-то адреса.
      </li>
      <li className={styles.list__item}>
        Сервер возвращает <b>preflight-ответ</b>, в котором разрешает или запрещает делать запрос, зависит от настроек
        сервера.
      </li>
      <li className={styles.list__item}>
        Если сервер разрешил делать запрос, браузер делает оригинальный запрос и получает ответ сервера.
      </li>
      <li className={styles.list__item}>
        Если сервер запретил запрос, в консоли браузера можно будет видеть информацию о CORS-ошибке во время попытки
        запроса.
      </li>
    </ul>
    <img className={styles.img} src={corsImg} alt="cors" />
    <p className={styles.description}>
      Разберем POST-запрос. Во время запроса браузер может добавлять заголовок{' '}
      <code className={styles.code}>Origin</code>, указывая на то, откуда был взят оригинальный HTML-файл.
    </p>
    <CopyBlock
      text={`POST HTTP/1.1
Origin: https://webiste.api.com
Host: webiste.api.com`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>
      Тогда сервер в ответ вернет заголовок <code className={styles.code}>Access-Control-Allow-Origin</code>, в котором
      будут указаны адреса с правами доступа к API. Значениями могут быть определенные адреса, либо{' '}
      <code className={styles.code}>*</code> — доступ разрешен с любого адреса.{' '}
    </p>
    <CopyBlock
      text={`// Если API приватный то будут указаны доступные адреса
Access-Control-Allow-Origin: https://webiste.api.com

// Если API публичный, доступ будет открыт всем
Access-Control-Allow-Origin: *`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <section className={styles.subsection}>
      <h3 className={styles.h3}>4.1 - Дополнительные материалы</h3>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <a className={styles.link} href="https://youtu.be/stvCHJZq5MI" target="_blank" rel="noopener noreferrer">
            Отличное видео о CORS (рекомендовано)
          </a>
        </li>
        <li className={styles.list__item}>
          <a
            className={styles.link}
            href="https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS"
            target="_blank"
            rel="noopener noreferrer"
          >
            CORS на MDN
          </a>
        </li>
      </ul>
    </section>
  </section>
))
